import cookieMonster from '../cookieMonster/cookieMonster.js';

const colorScheme = {
  attributeName: 'data-color-scheme',
  cookieName: 'colorscheme',
  expireInDays: 365,

  init(attributeName: string, cookieName: string) {
    this.attributeName = attributeName;
    this.cookieName = cookieName;
  },

  set(scheme: string): void {
    cookieMonster.set(this.cookieName, scheme, this.expireInDays);
    const rootElement = document.body.parentElement;
    rootElement.setAttribute(this.attributeName, scheme);
  }
};

declare global {
  interface Window {
    colorScheme: typeof colorScheme;
  }
}
window.colorScheme = colorScheme;

export default colorScheme;
